<template>
  <div :class="currDevice === 'mobile' ? 'mobile-login-setting' : 'login-setting'">
    <div class="no-login" v-if="!id">
      <span @click="showPanel('login')">登录</span>
      <span @click="showPanel('register')">注册</span>
    </div>
    <div class="login" v-else>
      <span>{{userPhone?userPhone:nickname}}</span>
      <span @click="logoutPanel">退出</span>
    </div>
    <channelSetting v-if="currDevice === 'mobile'"></channelSetting>
    <loginPanel v-model="panelStatus" :panelType="panelType" :currDevice="currDevice"></loginPanel>
  </div>
</template>

<script>
import { loginApi } from '../../api'
import { mapGetters } from 'vuex'
import loginPanel from '../loginPanel/indexPanel.vue'
import channelSetting from './channelSetting.vue'
export default {
  name: "loginSetting",
  props: {
    currDevice: String
  },
  computed: {
    ...mapGetters([
      'id',
      'userPhone',
      'nickname',
      'showRegisterStatus'
    ])
  },
  watch: {
    showRegisterStatus (val) {
      if (val) {
        this.showPanel('register')
      }
    }
  },
  components: {
    loginPanel,
    channelSetting
  },
  data () {
    return {
      panelType: 'login',
      panelStatus: false
    }
  },
  methods: {
    showPanel (type) {
      this.panelType = type;
      this.panelStatus = true
    },
    logoutPanel () {
      loginApi.logoutFunc().then(res => {
        if (res.code === 200) {
          location.reload()
        }
        else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.mobile-login-setting {
  padding: p2r(19px) p2r(16px);
  height: p2r(78px);
  box-sizing: border-box;
  display: flex;
  flex-flow: row-reverse;
  justify-content: space-between;
  align-items: center;
  font-size: p2r(12px);
  .login{
    span {
      cursor: pointer;
      display: inline-block;
      box-sizing: border-box;
      height: p2r(20px);
      line-height: p2r(20px);
      text-align: center;
      &:nth-of-type(1){
        color: rgba(179,32,34,1);
      }
      &:nth-of-type(2){
        width: p2r(36px);
        color: #333333;
        margin-left: p2r(5px);
      }
    }
  }
  .no-login{
    span{
      cursor: pointer;
      display: inline-block;
      box-sizing: border-box;
      width: p2r(36px);
      height: p2r(20px);
      line-height: p2r(20px);
      text-align: center;
      &:nth-of-type(1){
        color: rgba(179,32,34,1);
        border: p2r(1px) solid rgba(179,32,34,1);
      }
      &:nth-of-type(2){
        color: #333333;
        margin-left: p2r(5px);
      }
    }
  }
}
.login-setting {
  padding: p2r(8px) 0;
  height: p2r(40px);
  box-sizing: border-box;
  background: rgba(245, 247, 250, 1);
}
.login-setting{
  .login{
    max-width: p2r(1200px);
    margin: 0 auto;
    text-align: right;
    span {
      cursor: pointer;
      display: inline-block;
      box-sizing: border-box;
      height: p2r(24px);
      line-height: p2r(24px);
      text-align: center;
      &:nth-of-type(1){
        width: p2r(78px);
        color: rgba(179,32,34,1);
      }
      &:nth-of-type(2){
        width: p2r(60px);
        color: #333333;
        margin-left: p2r(5px);
      }
    }
  }
  .no-login{
    max-width: p2r(1200px);
    margin: 0 auto;
    text-align: right;
    span{
      cursor: pointer;
      display: inline-block;
      box-sizing: border-box;
      width: p2r(60px);
      height: p2r(24px);
      line-height: p2r(24px);
      text-align: center;
      &:nth-of-type(1){
        color: rgba(179,32,34,1);
        border: p2r(1px) solid rgba(179,32,34,1);
      }
      &:nth-of-type(2){
        color: #333333;
        margin-left: p2r(5px);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/headerComp/loginSetting.vue